/** What a `one_shot` call's card shows, read off the tool result's first line (CONTEXT.md "One-shot"). */
export type OneShotStatus = "passed" | "failed" | "aborted" | "interrupted";

export interface OneShotResult {
	loopId: string;
	/** Which run this call was: 1, or 2 for the follow-up. */
	run: number;
	of: number;
	status: OneShotStatus;
	/** The run's iteration, whose trace the card shows. */
	iterationId: string;
	/** Everything under the first line: what the platform found and the coding worker's report. */
	body: string;
}

/** A run of a one-shot the card can show the trace of. */
export interface OneShotRunRef {
	loopId: string;
	iterationId: string;
}

const HEADER = /^one-shot (\S+) · run (\d+) of (\d+) · (passed|failed|aborted|interrupted) · iteration (\S+)(?:\n\n([\s\S]*))?$/;

/** The first line the tool writes, then its body; undefined for a refusal or any other text. */
export function readOneShotResult(text: string): OneShotResult | undefined {
	const m = HEADER.exec(text);
	if (!m) return undefined;
	return { loopId: m[1]!, run: Number(m[2]), of: Number(m[3]), status: m[4] as OneShotStatus, iterationId: m[5]!, body: m[6] ?? "" };
}

/** The run the card shows: the result's once it is in, else the one announced while the call runs. */
export function runOf(read: OneShotResult | undefined, announced: OneShotRunRef | undefined): OneShotRunRef | undefined {
	return read ? { loopId: read.loopId, iterationId: read.iterationId } : announced;
}
